module.exports = __webpack_public_path__ + "static/ux_8_1_eg-616cde8bf1dd0f5eb5dcfa0fe0d6b2ef.png";